import WebAuthService from "./WebAuthService";

import {getConfig} from '../config';


class AuthService {

  constructor() {
    this.ozWebAuthService = new WebAuthService({
      userPoolId: getConfig("cognitoPoolId"),
      clientId: getConfig("cognitoClientId"),
      region: getConfig("cognitoRegion")
    });
  }

  refresh(){
    return new Promise((resolve, reject) => {
      let user = JSON.parse(localStorage.getItem(getConfig("userLocalStorage")));
      this.ozWebAuthService.refresh(user.RefreshToken).then(response => {
        response["RefreshToken"] = user.RefreshToken; //valutare se spostarlo in ozWebAuthService
        localStorage.setItem(getConfig("userLocalStorage"), JSON.stringify(response));  
        resolve(true);
      }).catch(error => {
        // console.log(error);
        localStorage.setItem(getConfig("userLocalStorage"), null);  
        reject(error);
      });
    });
  }

  changePassword(oldPassword, newPassword){
    return new Promise((resolve, reject) => {
      let user = JSON.parse(localStorage.getItem(getConfig("userLocalStorage")));
      this.ozWebAuthService.changePassword(oldPassword, newPassword, user.AccessToken).then(response => {
        resolve(true);
      }).catch(error => {
        reject(error);
      });
    });
  }

  logout(){
    localStorage.setItem(getConfig("userLocalStorage"), null);
  }
  
}

const service = new AuthService(); 
export default service;
